import React, { Component } from 'react';
import Proptypes from 'prop-types';
import { stripHtml } from '../../utils/helpers';
import {uniqBy} from 'lodash';

const announcementStyles = {
  container: {
    maxHeight: 300,
    overflowY: 'auto',
  },
  anchor: {
    padding: 0,
    margin: 0,
  },
  anchorCr: {
    padding: 0,
    margin: 0,
    color: 'inherit',
    textDecorationLine: 'underline',
  },
  icon: {
    margin: '0 4px',
    fontSize: '.8em',
  }
}
/**
 * @description 'Announcements' section of VDP.
 * @extends {Component<AnnouncementProps>}
 * 
 * **Update (MP-2366) - 2026.09.03**: 
 *  - Render urls as external links.  
 *  - Remove duplicate values.
 *  - Use comma-separated lines (_except if comma is part of a number_)
 */
class Announcements extends Component {
  render() {
    const {description="", announcements="", blockAnnouncements="", isCr=false} = this.props;
    const arr = uniqBy([
      // remove leading/trailing comma(s)
      description.replace(/^,|,$/,''),
      announcements.replace(/^,|,$/,''),
      blockAnnouncements.replace(/^,|,$/,''),
    ])
      .filter(text => text)
      .join(",")
      .split(/(?<!\d),|,(?!\d)/) // don't split on commas that are part of a number (e.g. $1,000)
      .filter(text => text.trim() !== '') // remove empty strings
      .map((text, index) => {
        let urlText = '';
        if (/https?:\/\//i.test(text)) {
          urlText = text.match(/https?:\/\/[^\s]+/i)[0];
        }
        return urlText
        ? (
          <div key={index}>
            <p style={{margin: 2}} >{text.replace(/https?:\/\/[^\s]+/i, '')}</p>
            <a href={urlText} style={isCr ? announcementStyles.anchorCr : announcementStyles.anchor} target="_blank" rel="noopener noreferrer">
              {urlText}
              <i className="fa fa-external-link-alt" style={announcementStyles.icon}/>
            </a>
          </div>)
        : (<p style={{margin: 2}} key={index}>{stripHtml(text)}</p>);
    });

    return <div style={announcementStyles.container}>{arr.length ? arr : <p>No Announcements</p>}</div>;
  }
}

Announcements.propTypes = {
  description: Proptypes.string,
  announcements: Proptypes.string,
  blockAnnouncements: Proptypes.string,
};

export default Announcements;

/**
 * @typedef {Object} AnnouncementProps
 * @property {string} description
 * @property {string} announcements
 * @property {string} blockAnnouncements
 * @property {boolean|undefined} [isCr=false] - Applies special styling for link in CR
 */